export default "__VITE_ASSET__407edc88__$_?component__"